import { Suspense, useRef, useState } from "react";
import { Billboard, Html, useTexture, useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

export const AVATAR_SRC = "/avatars/doctor-selvix-original.png";
const H = 2.5;
const W = H * (1024 / 1536);

function SelvixSprite({ onClick }) {
  const tex = useTexture(AVATAR_SRC);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.anisotropy = 8;
  const [hover, setHover] = useState(false);
  return (
    <Billboard lockX lockZ>
      <mesh
        position={[0, H / 2, 0]}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        onPointerOver={() => {
          setHover(true);
          document.body.style.cursor = "pointer";
        }}
        onPointerOut={() => {
          setHover(false);
          document.body.style.cursor = "auto";
        }}
      >
        <planeGeometry args={[W, H]} />
        <meshBasicMaterial map={tex} transparent alphaTest={0.04} toneMapped={false} side={THREE.DoubleSide} />
      </mesh>
      {hover && (
        <Html position={[0, H + 0.25, 0]} center>
          <div className="whitespace-nowrap rounded-full bg-white/95 px-3 py-1 text-xs font-semibold text-sky-800 shadow">
            Parla con Doctor Selvix
          </div>
        </Html>
      )}
    </Billboard>
  );
}

// Predisposto per un futuro modello GLB/GLTF approvato e fedele all'originale.
function SelvixModel({ url, onClick }) {
  const { scene } = useGLTF(url);
  return <primitive object={scene} onClick={onClick} />;
}

function FloorRing() {
  const ref = useRef();
  useFrame(({ clock }) => {
    if (ref.current) ref.current.material.opacity = 0.35 + Math.sin(clock.elapsedTime * 2) * 0.15;
  });
  return (
    <mesh ref={ref} rotation-x={-Math.PI / 2} position={[0, 0.02, 0]}>
      <ringGeometry args={[0.7, 0.95, 48]} />
      <meshBasicMaterial color="#7EE0A8" transparent opacity={0.4} />
    </mesh>
  );
}

export function SelvixAvatar({ position, modelUrl, onClick }) {
  return (
    <group position={position}>
      <FloorRing />
      <Suspense fallback={null}>
        {modelUrl ? <SelvixModel url={modelUrl} onClick={onClick} /> : <SelvixSprite onClick={onClick} />}
      </Suspense>
    </group>
  );
}
